import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { http } from '../lib/api';

const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

export default function BlackFridayStrip() {
  const [status, setStatus] = useState(null);
  const [now, setNow] = useState(Date.now());
  const location = useLocation();

  useEffect(() => {
    http.get('/blackfriday/status').then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);

  if (!status || location.pathname === '/black-friday') return null;
  const expired = status.expiry && (status.expiry.includes('T') ? new Date(status.expiry) : new Date(status.expiry + 'T23:59:59')) < new Date(now);
  if (expired) return null;

  const diff = Math.max(0, new Date(status.launchAt).getTime() - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor(diff / 3600000) % 24;
  const m = Math.floor(diff / 60000) % 60;
  const s = Math.floor(diff / 1000) % 60;

  return (
    <Link to="/black-friday" data-testid="bf-teaser-strip"
      className="block bg-black border-b border-alp-gold/40 py-2 px-4 text-center hover:bg-[#171207] transition-colors">
      {status.live ? (
        <span className="text-xs sm:text-sm tracking-[0.12em] uppercase text-alp-gold font-semibold">
          🖤 Black Friday is LIVE — codes expire Sunday · <span className="underline">Shop now</span>
        </span>
      ) : (
        <span className="inline-flex items-center gap-2 flex-wrap justify-center text-xs sm:text-sm tracking-[0.1em] uppercase">
          <span className="text-alp-gold font-semibold">🖤 Black Friday</span>
          <span className="text-alp-cream font-mono tabular-nums" data-testid="bf-strip-countdown">{d}d {pad(h)}:{pad(m)}:{pad(s)}</span>
          <span className="text-alp-gold underline">Lock in your secret code →</span>
        </span>
      )}
    </Link>
  );
}
